import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResq = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "140 0 69 69",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "resq" }),
		/* @__PURE__ */ _jsx("path", { d: "M158.570628 4.294211 A33.8455 33.4756 0 1 1 149.020570 12.204609 L158.238742 23.091588 A19.9095 19.6915 0 1 0 167.788963 15.181383 Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: -6.2,
			width: 40.275,
			height: 12.4,
			transform: "translate(175.155 33.4756) rotate(49.7449)"
		})
	]
});
export default SvgResq;
